<template>
  <div class="edit">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>学生管理</Breadcrumb-item>
        <Breadcrumb-item href="/user/userTrackList">学员跟踪记录</Breadcrumb-item>
        <Breadcrumb-item>试听课预约失败记录</Breadcrumb-item>
      </Breadcrumb>
    </div>

    <Form ref="form" :model="formValidate" :label-width="90" class="form">
      <Row>
        <Col :sm="11" :md="5">
        <Form-item label="学生ID" prop="uid">
          <Input v-model.number="formValidate.uid" :maxlength="10"></Input>
        </Form-item>
        </Col>
        <Col :sm="11" :md="5">
        <Form-item label="学生姓名" prop="nickname">
          <Input readonly placeholder="只读"
                 v-model="formValidate.nickname" ></Input>
        </Form-item>
        </Col>
        <Col :sm="11" :md="5">
        <Form-item label="课程顾问" prop="adviserName">
          <Input readonly placeholder="只读"
                 v-model="formValidate.adviserName"></Input>
        </Form-item>
        </Col>
        <Col :sm="11" :md="5">
        <Form-item label="学习导师" prop="studyAdviserName">
          <Input readonly placeholder="只读"
                 v-model="formValidate.studyAdviserName"></Input>
        </Form-item>
        </Col>
      </Row>
      <Row>
        <Col :sm="22" :md="18">
        <Form-item label="失败原因:">
          <CheckBox :boxList="failReason" @on-select-change="onFailReasonChange"></CheckBox>
        </Form-item>
        </Col>
      </Row>
      <Row>
        <Col :sm="22" :md="18">
        <Form-item>
          <Input v-model="formData.otherReason" type="textarea" :rows="4" placeholder="其他/备注"></Input>
        </Form-item>
        </Col>
      </Row>
      <Row>
        <Col :sm="11" :md="7">
        <Form-item label="下次联系日期">
          <Date-picker type="datetime" format="yyyy-MM-dd HH:mm" placeholder="请选择日期"
                       @on-change="dateChange"
                       :value="formData.nextTimeDate"></Date-picker>
        </Form-item>
        </Col>
        <Col :sm="11" :md="6">
        <Form-item label="状态" prop="status">
          <Select v-model.number="formData.state">
            <Option v-for="item in $constant.handlerType" :value="item.code" :key="item.code">{{ item.text }}</Option>
          </Select>
        </Form-item>
        </Col>
        <Col :sm="11" :md="6">
        <Form-item style="text-align: center">
          <Button type="primary" @click="handleSubmit">提交</Button>
        </Form-item>
        </Col>
      </Row>
    </Form>
  </div>
</template>
<script>
  import Checkbox from 'iview/src/components/checkbox'
  import Row from 'iview/src/components/grid/row'
  import commonUtils from '@/tools/commonUtils.js'
  export default {
    components: {
      Row,
      Checkbox},
    data () {
      return {
        failReason: [],
        formData: {
          uid: '',
          nickName: '',
          nextTimeDate: '',
          reason: [],
          state: '',
          otherReason: '',
          feedBackType: 22,
        },
        formValidate: {
          uid: '',
          nickname: '',
          adviserName: '',
          studyAdviserName: '',
        },
      }
    },
    created () {
      let self = this
      self.$http.get('/adminConfig/getItemByItemType?itemType=' + 2).then(function (res) {
        self.failReason = res.data
      })
    },
    mounted () {
      let self = this
      let row = self.$route.query.row
      self.formValidate.uid = row.uid
      self.formData.uid = row.uid
      self.$http.get('/userList/queryByUid?uid=' + self.formValidate.uid).then(function (res) {
        self.formValidate.nickname = res.data.nickname
        self.formData.nickName = self.formValidate.nickname
        self.formValidate.adviserName = res.data.adviserName
        self.formValidate.studyAdviserName = res.data.studyAdviserName
      })
    },
    methods: {
      dateChange (value) {
        this.formData.nextTimeDate = value && this.$moment(value, 'YYYY-M-D H:m').format('X')
      },
      onFailReasonChange (val) {
        this.formData.reason = val
      },
      handleSubmit () {
        let self = this
        self.$http.post('/bookLesson/insertLessonFeedBack', {}, {
          transformRequest: [function (data, headers) {
            return JSON.stringify(self.formData)
          }],
          headers: {'Content-Type': 'application/json;charset=utf-8'},
        }).then(function (res) {
          self.loadingBind = false
          if (!res) {
            self.$Message.error('操作失败!')
          } else if (res.data > 0) {
            self.$Message.success('添加成功!')
            self.visible = false
            if (self.successCallback !== undefined) {
              self.successCallback()
            }
            self.$router.push({path: '/message/personMessage', query: {tabName: commonUtils.getShortNumByTraceType(21)}})
          } else {
            self.$Message.error(res.message)
          }
        })
      }
    },
    watch: {
    }
  }
</script>



// WEBPACK FOOTER //
// TrailLessonFailedReason.vue?33cb8416